import { render, staticRenderFns } from "./EbookItem.vue?vue&type=template&id=8a17e348&scoped=true&"
import script from "./EbookItem.vue?vue&type=script&lang=js&"
export * from "./EbookItem.vue?vue&type=script&lang=js&"
import style0 from "./EbookItem.vue?vue&type=style&index=0&id=8a17e348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a17e348",
  null
  
)

export default component.exports